import { FUTURES } from "../../../../../constants";

const sameSlug = (left, right) =>
  String(left || "").toUpperCase() === String(right || "").toUpperCase();

/**
 * Switches the active futures pair in redux and syncs `?pair=` in the URL.
 */
export const switchFuturesPair = ({
  dispatch,
  setSearchParams,
  currentPair,
  nextPair,
}) => {
  if (!nextPair?.slug) return;

  if (!sameSlug(currentPair?.slug, nextPair.slug)) {
    dispatch({
      type: FUTURES.CHANGE_PAIR,
      payload: nextPair,
    });
  }

  setSearchParams({
    pair: nextPair.slug,
  });
};
